import React from 'react';

import { Title } from 'components/Misc/Typography';
import { Input } from 'components/Misc/Form';

import { useUserCreateStore } from 'store/user/useUserCreateStore';

const Address = () => {
	// Use user's creation store
	const [address, onChange] = useUserCreateStore(state => [
		state.user.address,
		state.onChangeAddress
	]);

	return (
		<div className="grid md:grid-cols-2 gap-4">
			<Title
				title="Adrese"
				className="md:col-span-2 text-xl"
			/>
			
			<Input
				type="text"
				name="country"
				label="Valsts"
				value={address.country}
				onChange={onChange}
			/>
			
			<Input
				type="text"
				name="city"
				label="Pilsēta"
				value={address.city}
				onChange={onChange}
			/>
			
			<Input
				type="text"
				name="street"
				label="Iela"
				value={address.street}
				onChange={onChange}
			/>

			<Input
				type="text"
				name="zip"
				label="Pasta indeks"
				value={address.zip}
				onChange={onChange}
			/>
		</div>
	);
};

export default Address;
